import { ca } from '@cian/analytics';

import { getProduct, getPageNumber } from '../../utils/trackings';
import { IPageState } from '../../types/page';
import { TUser } from '../../api';
import { IFavoriteEntity } from '../../types/results';

/**
 * Клик по заголовку-ссылке
 */
export function trackTitleClick(
  pageData: IPageState,
  user: TUser,
  entityId: number,
  favoriteEntities: IFavoriteEntity[],
  total: number,
) {
  const product = getProduct(entityId, favoriteEntities);

  ca('eventEbc', {
    name: 'oldevent',
    category: 'ListingFavorites',
    action: 'to_card',
    label: 'card_header',
    user: {
      abGroup: pageData.abGroup,
      isAuthorized: user.isAuthenticated,
      userId: user.isAuthenticated ? user.userId : undefined,
    },
    page: {
      listingType: 'list',
      sortType: 'default',
      pageNumber: getPageNumber(total, product.position),
      offersQty: total,
      pageType: 'ListingFavorites',
      siteType: pageData.deviceType === 'phone' ? 'mobile' : pageData.deviceType,
    },
    products: [product],
  });
}
